import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { getUrl } from "./urls";
import { getAccessToken, getCompanyId } from "./utils";

export const FETCH_TIKTOK_PAGE_LIST = "FETCH_TIKTOK_PAGE_LIST";
export const SET_TIKTOK_SELECTED_PAGE = "SET_TIKTOK_SELECTED_PAGE";
export const UPDATE_TIKTOK_DURATION_FILTER = "UPDATE_TIKTOK_DURATION_FILTER";
export const FETCH_TK_METRICS_PENDING = "FETCH_TK_METRICS_PENDING";
export const FETCH_TK_METRICS_FULFILLED = "FETCH_TK_METRICS_FULFILLED";
export const FETCH_TK_METRICS_REJECTED = "FETCH_TK_METRICS_REJECTED";
export const FETCH_TK_METRICS = "FETCH_TK_METRICS";
export const FETCH_TK_PAGE_FOLLOWERS = "FETCH_TK_PAGE_FOLLOWERS";

export function fetchTiktokPagesList() {
    let page_details = [];
    let res = axios({
        method: "get",
        url: getUrl("social_token_list"),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            response.data.data.tokens.map((k, v) => {
                // console.log("first", k.platform);
                if (k.platform === "tiktok" && k.insight_feature === 1) {
                    page_details.push(k);
                }
            });
            return page_details;
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message);
            return err;
        });
    return {
        type: "FETCH_TIKTOK_PAGE_LIST",
        payload: res,
    };
}
// export const fetchTotalTkMetrics = (params) => {
//     //this is insights api...but we have to use search api
//     return axios({
//         method: "post",
//         url: getUrl("ig_insights_metrics"),
//         data: params,
//         headers: {
//             "Content-Type": "application/json",
//         },
//     });
// };

export function setSelectedPage(value) {
    return {
        type: "SET_TIKTOK_SELECTED_PAGE",
        payload: value,
    };
}

export function updateDurationFilter(value) {
    return {
        type: "UPDATE_TIKTOK_DURATION_FILTER",
        payload: value,
    };
}

export function fetchTiktokPageFollowers(params) {
    let res = axios({
        method: "get",
        url: `https://graph.facebook.com/v12.0/${params.page_id}?fields=followers_count&access_token=${params.access_token}`,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message);
            return err;
        });
    return {
        type: "FETCH_TK_PAGE_FOLLOWERS",
        payload: res,
    };
}
export const fetchFollowersGrowth = (data) => {
    return axios.get(
        getUrl("tiktok_followers") + `?start_date=${data.start_date}&end_date=${data.end_date}&page_id=${data.page_id}&agreegate_interval=yearly`,
        {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "access-token": getAccessToken(),
            },
        },
    );
};
export const fetchAllTKPostDetails = (data) => {
    let params = new URLSearchParams();
    params.append("start_date", data.start_date);
    params.append("end_date", data.end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("apply_exclusion", "no");
    // params.append("post_type", "0");
    params.append("platform", ["1cbacd32-a97d-11ea-89d1-02f9d9f14362"]);
    params.append("custom_query", `post_author.username:"${data.handler}"`);
    // params.append("custom_query", `post_author.username:"aliane_hero"`);

    switch (data.name) {
        // case "total-followers":
        //     params.append("aggs-interval", "year");
        //     // params.append("aggs", "followers_overtime"); // new api will be provided
        //     break;

        case "total-reach":
            params.append("aggs-interval", "year");
            params.append("aggs", "total_estimated_reach");
            break;

        case "total_engagement":
            params.append("aggs-interval", "year");
            params.append("aggs", "like-count-stats,share-count-stats,comment-count-stats,view-count-stats");
            break;

        case "total-posts":
            // params.append("aggs-interval", "year");
            break;

        case "total-posts-likes":
            params.append("aggs-interval", "year");
            params.append("aggs", "like-count-stats");
            break;

        case "total-posts-comments":
            params.append("aggs-interval", "year");
            params.append("aggs", "comment-count-stats");
            break;

        case "total-posts-views":
            params.append("aggs-interval", "year");
            params.append("aggs", "view-count-stats");
            break;

        default:
            break;
    }

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};

export const fetchDataFromTiktok = (ApiCall, data) => {
    return (dispatch) => {
        const chartName = data["name"];

        dispatch({
            type: "FETCH_TK_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        let presentDurationData = ApiCall(data).then((res) => ({ name: "presentDurationData", data: res.data }));
        let data2 = { ...data };
        let durationGap = moment(data.end_date).diff(moment(data.start_date), "days", true);
        data2["start_date"] = moment(data.start_date)
            .subtract(durationGap + 1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        data2["end_date"] = moment(data.start_date).subtract(1, "day").format("YYYY-MM-DD");

        let previousDurationData = ApiCall(data2).then((res) => ({ name: "previousDurationData", data: res.data }));

        Promise.all([presentDurationData, previousDurationData])
            .then((response) => {
                // console.log("presentt", response);
                dispatch({
                    type: "FETCH_TK_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response,
                        durationGap,
                    },
                });
                return response;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_TK_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};
export const fetchTKRecentPostsData = (dispatch, params, chartName) => {
    dispatch({
        type: "FETCH_TK_METRICS_PENDING",
        payload: { chart_name: chartName },
    });
    let res = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TK_METRICS_FULFILLED",
                payload: { chart_name: chartName, response: response.data?.hits?.hits },
            });
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: "FETCH_TK_METRICS_REJECTED",
                payload: { chart_name: chartName },
            });
        });
};
export function fetchTKChartMetrics(params) {
    const chartName = params["name"];
    delete params["name"];

    return function (dispatch) {
        // if (params?.isAverage) dispatch(fetchAverageIgMetrics(params, chartName));
        // console.log("audience_metrics_by_gender", params, chartName);
        dispatch({
            type: "FETCH_TK_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let resp = axios({
            method: "post",
            url: getUrl("searchaggs"),
            data: params,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_TK_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: res.data },
                });
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
                dispatch({
                    type: "FETCH_TK_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
}
export const fetchTKFollowersCount = (params) => {
    const chartName = params["name"];
    let interval = null;
    switch (params.agreegate_interval) {
        case "day":
        case "daily":
            interval = "daily";
            break;

        case "week":
        case "weekly":
            interval = "weekly";
            break;
        case "month":
        case "monthly":
            interval = "monthly";
            break;

        case "year":
        case "yearly":
            interval = "yearly";
            break;

        default:
            interval = "daily";
    }

    return (dispatch) => {
        dispatch({
            type: "FETCH_TK_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let res = axios
            .get(
                getUrl("tiktok_followers") +
                    `?start_date=${params.start_date}&end_date=${params.end_date}&page_id=${params.page_id}&agreegate_interval=${interval}`,
                {
                    cache: false,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        "access-token": getAccessToken(),
                    },
                },
            )
            .then((response) => {
                dispatch({
                    type: "FETCH_TK_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: response.data?.data },
                });
            })
            .catch((error) => {
                console.log(error);

                dispatch({
                    type: "FETCH_TK_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const fetchTKEngagementRate = (params) => {
    const chartName = params["name"];

    let interval = null;
    switch (params.agreegate_interval) {
        case "day":
        case "daily":
            interval = "daily";
            break;

        case "week":
        case "weekly":
            interval = "weekly";
            break;
        case "month":
        case "monthly":
            interval = "monthly";
            break;

        case "year":
        case "yearly":
            interval = "yearly";
            break;

        default:
            interval = "daily";
    }

    return (dispatch) => {
        dispatch({
            type: "FETCH_TK_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        const followersData = axios
            .get(
                getUrl("tiktok_followers") +
                    `?start_date=${params.start_date}&end_date=${params.end_date}&page_id=${params.page_id}&agreegate_interval=${interval}`,
                {
                    cache: false,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        "access-token": getAccessToken(),
                    },
                },
            )
            .then((response) => ({ name: "followersOverTime", data: response.data.data }));

        delete params.page_id;
        delete params.agreegate_interval;

        const engagementData = axios({
            method: "post",
            url: getUrl("searchaggs"),
            data: params,
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => ({ name: "engagementOverTime", data: response.data }));

        Promise.all([engagementData, followersData])
            .then((res) => {
                dispatch({
                    type: "FETCH_TK_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: res },
                });
            })
            .catch((error) => {
                console.log(error);

                dispatch({
                    type: "FETCH_TK_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};
